import { api, fmtDT } from "../lib/api";
import { useState } from "react";
import { PageHeader, useLoad, Pager } from "../components/common";

export default function AuditPage() {
  const [page, setPage] = useState(1);
  const [data] = useLoad(async () => (await api.get("/audit", { params: { page } })).data, [page]);
  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit log" sub="Every administrative change with actor, time, old and new value, and reason." />
      <div className="panel overflow-x-auto">
        <table className="dt" data-testid="audit-table"><thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Target</th><th>Old</th><th>New</th><th>Reason</th></tr></thead>
          <tbody>{(data?.items || []).map((a) => (
            <tr key={a.id}><td className="mono text-xs whitespace-nowrap">{fmtDT(a.at)}</td><td className="text-xs">{a.actor_name}</td><td className="text-xs font-medium">{a.action}</td>
              <td className="mono text-[11px]">{a.target_type}:{String(a.target_id || "").slice(0, 14)}</td>
              <td className="mono text-[11px] max-w-[220px] truncate" title={JSON.stringify(a.old)}>{a.old != null ? JSON.stringify(a.old) : ""}</td>
              <td className="mono text-[11px] max-w-[260px] truncate" title={JSON.stringify(a.new)}>{a.new != null ? JSON.stringify(a.new) : ""}</td>
              <td className="text-xs">{a.reason || ""}</td></tr>))}
          </tbody></table>
        {data && <Pager page={page} total={data.total} onPage={setPage} />}
      </div>
    </div>
  );
}
